import { Stack, styled } from '@mui/system';
import { TextFieldSelect } from 'shell/OnlineBookingTheme/components';
import { Button, Typography } from '@mui/material';


const CancellationRoot = styled('div', { target: 'CancellationRoot' })(({ theme }) => ({
    padding: theme.spacing(0, 2, 2, 2),
    textAlign: 'left',
}))

const CancellationHintText = styled('span', { target: 'CancellationHintText' })(({ theme }) => ({
    display: 'block',
    fontSize: '0.875rem',
    color: theme.vars.palette.secondary.textIconColor,
    marginBottom: theme.spacing(3)
}));

const CancellationTitle = styled(Typography, { target: 'CancellationRoot' })(({ theme }) => ({
    marginBottom: theme.spacing(1),
    fontSize: '1rem',
    fontWeight: '500'
}))

export const CancellationCustomMessage = styled('div', { target: 'CancellationCustomMessage' })(({ theme }) => ({
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(3),
}))

const ReasonTextField = styled(TextFieldSelect, { target: 'ReasonInput' })(({ theme }) => ({
    marginBottom: theme.spacing(3)
}))

const StyledBottomButtons = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 0),
    height: '40px'
}))

const buttonWrapper = styled(Button)(({ theme }) => ({
    textOverflow: 'ellipsis',
    fontSize: '0.875rem',
    overflow: 'hidden',
    display: 'block',
    width: 'auto',
}))

const StyledMainButton = styled(buttonWrapper)(({ theme }) => ({
    color: theme.vars.palette.primary.textButtonColor,
    background: theme.vars.palette.primary.main,
    lineHeight: theme.spacing(2),
    padding: theme.spacing(1, 4),
    maxWidth: '200px',
    "&:hover": {
        background: theme.vars.palette.primary.main,
        color: theme.vars.palette.primary.textButtonColor,
        boxShadow: `2px 4px 12px 2px rgb(${theme.vars.palette.primary.mainChannel} / 0.25)`
    },
    "&.Mui-disabled": {
        background: theme.palette.blueGrey[100]
    }
}));

const StyledSecondaryButton = styled(buttonWrapper)(({ theme }) => ({
    color: theme.vars.palette.primary.main,
    maxWidth: '150px',
    padding: theme.spacing(1),
    paddingLeft: '12px',
    paddingRight: '12px'
}));

export { CancellationRoot, CancellationHintText, CancellationTitle, ReasonTextField, StyledBottomButtons, StyledMainButton, StyledSecondaryButton }